<template>
  <div class="page-container">
    <div v-if="componentLoading" class="please-wait">
      <PleaseWait></PleaseWait>
    </div>
    <CommunityCard v-else class="p-4">
      <h3 class="text-inherit mb-3">{{ scenario.name }}</h3>
      <div class="row">
        <div class="col-12 col-md-5 d-flex flex-column">
          <div class="d-flex">
            <img
              class="device-thumb"
              :src="deviceThumb"
              title
              alt="monitor image"
            />
          </div>

          <ScenarioActions :scenario="scenario" :isCtgi="isCtgi" />

          <div v-if="scenario.contributed_by" class="d-flex align-items-center">
            <i class="material-icons text-secondary">person</i>
            <em>Contributed By:&nbsp;</em>
            <router-link
              :to="{
                name: 'view-user',
                params: { id: scenario.contributed_by.uuid_id },
              }"
            >
              <span class="element-label">
                {{ scenario.contributed_by.first_name }}
                {{ scenario.contributed_by.last_name }}
              </span>
            </router-link>
          </div>
          <div class="d-flex align-items-center">
            <i class="material-icons text-secondary">star</i>
            <em>Favourited:&nbsp;</em>
            <span class="element-label">
              <em>{{ scenario.number_favourites }}</em>
            </span>
          </div>
          <div class="d-flex align-items-center">
            <i class="material-icons text-secondary">save_alt</i>
            <em>Downloads:&nbsp;</em>
            <span class="element-label">
              <em>{{ scenario.num_downloads }}</em>
            </span>
          </div>
        </div>
        <div class="col">
          <div>
            <img
              :src="patientPhoto"
              class="patient-photo rounded-circle"
              alt="patient photo"
            />
          </div>
          <div class="my-3">{{ scenario.description }}</div>

          <ul
            v-if="scenario.tags"
            class="p-0 scenario-tags d-flex justify-content-start flex-wrap my-3"
          >
            <li
              :key="tag.id"
              v-for="tag in scenario.tags"
              :class="{ selected: tag.isCurrentlySelected }"
            >
              {{ tag.title }}
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="scenario"
        class="d-none d-sm-block col-12 align-self-end mt-3 bg-light py-2 px-3 border-radius-md"
      >
        <ScenarioElements
          :language="scenario.unicode_language_identifier"
          :durationInSeconds="scenario.duration_in_seconds"
          :numChecklistItems="scenario.num_checklist_items"
          :numEvents="scenario.num_events"
          :hasMedia="scenario.has_images"
          :hasSounds="scenario.has_sounds"
          :hasLabs="scenario.has_labs"
          :isCtgi="isCtgi"
        ></ScenarioElements>
      </div>
    </CommunityCard>
  </div>
</template>

<script>
import ScenarioActions from "../components/ScenarioActions";
import ScenarioService from "../services/scenarios.service";
import ScenarioHelper from "../utils/scenario.helper";
import ScenarioElements from "../components/ScenarioElements";
import PleaseWait from "../components/PleaseWait";
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "ScenarioView",
  components: {
    CommunityCard,
    ScenarioActions,
    ScenarioElements,
    PleaseWait,
  },
  beforeMount() {
    this.scenario = {};
    this.getScenarios(this.$route.params.uuidId);
  },
  data: function () {
    return {
      componentLoading: true,
      scenario: {},
      isFavouritedByUser: false,
      isCtgi: false,
      deviceThumb: null,
      patientPhoto: require("../assets/patient-photos/" +
        ScenarioHelper.getFilenameForPatientPhoto()), // We don't have patient ID anywhere
    };
  },
  methods: {
    getScenarios(uuidId) {
      this.componentLoading = true;

      ScenarioService.scenario(uuidId).then((data) => {
        this.scenario = data;

        this.tags = data.tags;
        this.isFavouritedByUser = data.is_favourited_by_current_user;
        this.isCtgi =
          this.scenario.object_url &&
          this.scenario.object_url.includes(".ctgi");

        this.deviceThumb = this.isCtgi
          ? require("../assets/device/CTGi.png")
          : require("../assets/device/" +
              ScenarioHelper.getFilenameForDeviceThumb(
                this.scenario.device_id
              ));

        this.componentLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.page-container {
  max-width: 900px;
  margin: 0 auto;
}

.scenario-tags li {
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.patient-photo {
  max-height: 125px;
  width: auto;
}

.device-thumb {
  height: auto;
  width: auto;
  max-width: 250px;
}

.please-wait {
  height: 60vh;
}

.border-radius-md {
  border-radius: 0.8rem;
}
</style>
